import { Button } from "react-migration/components/DeprecatedButton";
import { Icon } from "react-migration/components/Icon";
import { Stepper } from "react-migration/components/Stepper";
import classNames from "clsx";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { CreateSkipTraceOrderStep } from "../../typings/SkipTraceOrderStep";
import logSiteCardEvent from "react-migration/lib/util/logSiteCardEvent";

type CreateSkipTraceHeaderProps = {
  currentStep: CreateSkipTraceOrderStep;
  onBackToSitesClicked: () => void;
};

export const CreateSkipTraceHeader = ({
  currentStep = CreateSkipTraceOrderStep.SelectSites,
  onBackToSitesClicked,
}: CreateSkipTraceHeaderProps) => {
  const { t } = useTranslation();

  if (currentStep === CreateSkipTraceOrderStep.OrderError) {
    return null;
  }

  const steps = [
    { key: CreateSkipTraceOrderStep.SelectSites, label: "Select sites" },
    { key: CreateSkipTraceOrderStep.Summary, label: "Summary" },
  ];

  const onBackToSitesButtonClicked = () => {
    logSiteCardEvent({ name: "Skip Trace - Back To Sites" });
    onBackToSitesClicked();
  };

  return (
    <div
      data-testid="create-skip-trace-header"
      className={classNames(
        "flex",
        "w-full",
        "border-b",
        "border-border-action",
        "px-5",
        "py-1",
        "grid",
        "grid-cols-5"
      )}
    >
      <div className="flex col-span-1">
        <Button.Borderless
          onClick={onBackToSitesButtonClicked}
          className="shadow-none! flex-none text-text-base-tertiary px-0! gap-x-1"
        >
          <Icon icon="icon-lt-arrow-left-s-line" cursor={"pointer"} />
          {t("sites.skip_tracing.back_to_sites")}
        </Button.Borderless>
      </div>
      <div className="flex col-span-3">
        <Stepper currentStep={currentStep} steps={steps} containerClassNames="border-none!" />
      </div>
    </div>
  );
};
